import React, { useEffect, useState, createElement } from 'react';
import { Hero } from './components/Hero';
import { Testimonials } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { ProductOverview } from './components/ProductOverview';
import { Tomos } from './components/Tomos';
import { Bonos } from './components/Bonos';
import { Pricing } from './components/Pricing';
import { PackElite } from './components/PackElite';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { Comparison } from './components/Comparison';
import { Footer } from './components/Footer';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingCart } from 'lucide-react';
export function App() {
  const [showStickyCTA, setShowStickyCTA] = useState(false);
  // Meta Pixel
  useEffect(() => {
    // Avoid duplicate initialization
    if ((window as any).fbq) return;
    const f = window as any;
    const n = f.fbq = function (...args: any[]) {
      n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
    f.fbq('init', '1904779843432668');
    f.fbq('track', 'PageView');
  }, []);
  useEffect(() => {
    const handleScroll = () => {
      // Show sticky CTA after scrolling past the hero section (approx 600px)
      if (window.scrollY > 600) {
        setShowStickyCTA(true);
      } else {
        setShowStickyCTA(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <div className="min-h-screen bg-slate-50 font-sans selection:bg-brand-accent/30 selection:text-brand-dark overflow-x-hidden" data-id="element-0">
      <Hero data-id="element-1" />
      <Testimonials limit={3} data-id="element-2" />
      <PainPoints data-id="element-3" />
      <ProductOverview data-id="element-4" />
      <Tomos data-id="element-5" />
      <Bonos data-id="element-6" />
      <Pricing id="pricing" data-id="element-7" />
      <PackElite data-id="element-8" />
      <Testimonials limit={7} title="LO QUE DICEN LOS PROFESORES QUE YA LO USAN" dark data-id="element-9" />
      <Guarantee data-id="element-10" />
      <FAQ data-id="element-11" />
      <Comparison data-id="element-12" />
      <Pricing id="pricing-bottom" data-id="element-13" />
      <Footer data-id="element-14" />

      {/* Mobile Sticky CTA */}
      <AnimatePresence data-id="element-15">
        {showStickyCTA && <motion.div initial={{
        y: 100,
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} exit={{
        y: 100,
        opacity: 0
      }} className="fixed bottom-0 left-0 right-0 p-4 bg-white/90 backdrop-blur-md border-t border-slate-200 shadow-[0_-10px_40px_rgba(0,0,0,0.1)] z-50 md:hidden flex justify-center" data-id="element-16">
            <button onClick={scrollToPricing} className="w-full max-w-sm bg-brand-accent text-brand-dark font-bold py-3 px-6 rounded-xl shadow-lg flex items-center justify-center" data-id="element-17">
              <ShoppingCart className="w-5 h-5 mr-2" data-id="element-18" />
              QUIERO MI PACK ÉLITE
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}